import React,{Component} from  'react';
import {connect} from 'react-redux';
// utils
import {Translations} from '../../../../utils';
// constant
import {FORM_REFS} from '../../../../constants';
// restClient
import {eapiClient, aemHostClient} from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
//style
import './styles.css';

class CreateCountryFormSignatory extends Component{
  constructor(props) {
    super(props)
    this.state={}
  }
  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentWillMount(){
    let apiURL = "/aemData/formData/json_create-declaration-signatory";
    if(this.props.mode === "edit"){
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({formJson: data});
    });
  }

  getFormData = (formData) => {
    this.setState({formData});
  }

  onFormSubmit = (event, apiURL) => {
    if(this.props.match.params) {
      var {caseId} = this.props.match.params;
    }
    var requestData = {
      ...this.state.formData,
      caseId:caseId
    };
    requestData.entityId = this.props.entityId;

    if(this.props.mode === 'edit') {
      apiURL = apiURL + "/" + this.state.formData.id;
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(apiURL, {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
    .then(({data}) => {
      var key = window.sessionStorage.getItem("getCurrentDropDown");
      window.sessionStorage.setItem('key'+ key, data.responseData.id);
      this.props.history.goBack();
    });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups(){
    let formData;
    if(this.props.currentDeclarationSignatory !== undefined) {
      formData = {...this.props.currentDeclarationSignatory};
    }else {
      formData = {};
    }
    const properties = {
      contactId: this.props.match.params.contactId,
      contactType: this.props.match.params.contactType,
      formData,
      editType: 'create-country-form-declaration-signatory',
      pathname: this.props.history.location.pathname
    };
    if(this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined){
      return (
        <Dynamicform mode={this.props.mode}
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
        getFormData={this.getFormData}
        history={this.props.history}
        match={this.props.match}
        onFormSubmit={this.onFormSubmit}
        onFormCancel={this.onFormCancel}
        lang = {this.props.lang.currentLang.lang}
        translatedData ={this.props.lang.translatedData}
        flag={this.props.lang.currentLangFlag.flag}/>
      );
    }
  }

  render(){
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : {};
    return(
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">{this.translations(pageTitle.pageHeading)}</h2>
      <p className="form-required-desc">{this.translations(pageTitle.descriptionText)}</p>
      </div>
      {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {

  let currentDeclarationSignatory = undefined;
  let entityId;
  if(props.match.params) {
    var {contactId} = props.match.params;
    var {caseId} = props.match.params;
    if(contactId && state.persons.length > 0){
      state.persons.forEach(declarationSignatory => {
        if(declarationSignatory.id === contactId) {
          currentDeclarationSignatory = declarationSignatory;
        }
      });
    }
    if(caseId && Object.keys(state.entities).length > 0){
      for(var k in state.entities){
        if(state.entities[k].caseId === caseId){
          entityId = state.entities[k].entityId;
        }
      }
    }
  }
  return {
    currentDeclarationSignatory,
    mode: currentDeclarationSignatory !== undefined ? 'edit' : '',
    entityId,
    lang:state.lang
  };
}

export default connect(mapStateToProps)(CreateCountryFormSignatory);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/createCountryFormSignatory.js